import React from "react";
import { SearchBar } from "../SearchBar/SearchBar";

export default function MapSearch({ onSearch }) {
    return (
        <SearchBar
            onSearch={(query) => {
                onSearch(query);
            }}
        />
    );
}
